import { createSlice, createAction } from '@reduxjs/toolkit';
import initialState from '../../../domain/entities/uf';

const fetchUfParams = createAction('fetchUfParams');

function fetchUfParamsSuccess(state, action) {
  const { tipo, valor, fecha } = action.payload;

  state.successFetching = true;
  state.errorFetching = false;
  state.type = tipo;
  state.value = valor;
  state.date = fecha;
}

function fetchUfParamsError(state) {
  state.successFetching = false;
  state.errorFetching = true;
  state.type = null;
  state.value = null;
  state.date = null;
}

const ufReducer = createSlice({
  name: 'uf',
  initialState,
  reducers: {
    fetchUfParamsSuccess,
    fetchUfParamsError,
  },
});

export const ufActions = {
  ...ufReducer.actions,
  fetchUfParams,
};

export default ufReducer.reducer;
